import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AD_FORMAT_QUERY_KEYS } from '@/entities/ad-format';
import {
  confirmImport,
  createImport,
  getImport,
  updateImport,
} from '../api/format-specs-admin.api';
import { FORMAT_SPECS_ADMIN_KEYS } from '../api/query-keys';

export function usePreviewImport() {
  return useMutation({
    mutationFn: ({ files, idempotencyKey }: { files: File[]; idempotencyKey: string }) =>
      createImport(files, idempotencyKey),
  });
}

export function useRefreshImport() {
  return useMutation({ mutationFn: (id: string) => getImport(id) });
}

export function useUpdateImport() {
  return useMutation({
    mutationFn: ({
      id,
      ...body
    }: {
      id: string;
      resolutions?: Record<string, 'file' | 'current'>;
      confirmBreaking?: boolean;
    }) => updateImport(id, body),
  });
}

export function useConfirmImport() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => confirmImport(id),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: FORMAT_SPECS_ADMIN_KEYS.all }),
        queryClient.invalidateQueries({ queryKey: AD_FORMAT_QUERY_KEYS.formatSpecs() }),
      ]);
    },
  });
}
